<div class="d-flex justify-content-center align-items-center">
  <svg width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"
       [ngStyle]="{'transform': 'scale('+scale+')'}">
    <g>
      <animateTransform attributeName="transform" type="rotate" values="0 33 33;270 33 33" begin="0s" dur="1.4s"
                        fill="freeze" repeatCount="indefinite"/>
      <circle fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30" stroke-dasharray="187"
              stroke-dashoffset="610">
        <animate attributeName="stroke" values="#9FDAFF;#42a1e8;#2A6A91;#42a1e8;#9FDAFF" begin="0s" dur="5.6s"
                 fill="freeze" repeatCount="indefinite"/>
        <animateTransform attributeName="transform" type="rotate" values="0 33 33;135 33 33;450 33 33" begin="0s"
                          dur="1.4s" fill="freeze" repeatCount="indefinite"/>
        <animate attributeName="stroke-dashoffset" values="187;46.75;187" begin="0s" dur="1.4s" fill="freeze"
                 repeatCount="indefinite"/>
      </circle>
    </g>
  </svg>
</div>
